import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms & Conditions</h1>
          <p className="text-gray-600">Last updated on Oct 10 2025</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-md p-8 space-y-6">
          <section>
            <p className="text-gray-700 leading-relaxed">
              For the purpose of these Terms and Conditions, The term "we", "us", "our" used anywhere on this page shall mean <strong>NEHA KEDAR KHAPARE</strong>, whose registered/operational office is <strong>Flat No.4, Saudamini Apartment, 100 Feet Road, Opposite Sarovar Hotel, Sangli Miraj Kupwad Municiple Corporation, Miraj, Sangli Sangli MAHARASHTRA 416415</strong>. "you", "your", "user", "visitor" shall mean any natural or legal person who is visiting our website and/or agreed to purchase from us.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              Your use of the website and/or purchase from us are governed by following Terms and Conditions:
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              The content of the pages of this website is subject to change without notice.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              Your use of any information or materials on our website and/or product pages is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through our website and/or product pages meet your specific requirements.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              Our website contains material which is owned by or licensed to us. This material includes, but are not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              All trademarks reproduced in our website which are not the property of, or licensed to, the operator are acknowledged on the website.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              Unauthorized use of information provided by us shall give rise to a claim for damages and/or be a criminal offense.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              From time to time our website may also include links to other websites. These links are provided for your convenience to provide further information.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              You may not create a link to our website from another website or document without NEHA KEDAR KHAPARE's prior written consent.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              Any dispute arising out of use of our website and/or purchase with us and/or any engagement with us is subject to the laws of India.
            </p>
          </section>

          <section>
            <p className="text-gray-700 leading-relaxed">
              We, shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.
            </p>
          </section>
        </div>

        {/* Back Button */}
        <div className="mt-6 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-indigo-600 hover:text-indigo-700 font-semibold"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
